import { Textarea as IOTextarea } from '@descomplica/foundation-ui-components';
import React from 'react';
import styled from 'styled-components';

type Props = Partial<{
  name: string;
  label: string;
  placeholder: string;
  errorMessage: string;
  defaultValue: string;
  value: any;
  required: boolean;
  autoFocus: boolean;
  autoComplete: string;
  pattern: string;
  minLength: number;
  maxLength: number;
  type: string;
  onChange: (name: string) => void;
  onBlur?: () => void;
}>;

const TextareaWrapper = styled.div`
  div:first-child > div:first-child {
    width: 100% !important;
  }
`;

export const Textarea: React.FC<Props> = (props) => {
  return (
    <TextareaWrapper>
      <IOTextarea
        onChange={props.onChange}
        onBlur={props.onBlur}
        label={props.label || props.placeholder}
        placeholder={props.placeholder || props.label}
        errorMessage={props.errorMessage}
        defaultValue={props.defaultValue}
        value={props.value}
      />
    </TextareaWrapper>
  );
};
